import { Component, OnInit } from '@angular/core';
import { ModalExtended } from 'ngx-dynamic-modal';
import { VnaCallerIdService } from '../../services/vna-caller-id.service';

@Component({
  selector: 'app-caller-id-campaigns',
  templateUrl: './caller-id-campaigns.component.html',
  styleUrls: ['./caller-id-campaigns.component.scss']
})
export class CallerIdCampaignsComponent extends ModalExtended implements OnInit {

  data: Object;
  loading = false;
  camps: object[] = [];

  constructor(private callerIdService: VnaCallerIdService) {
    super();

  }

  onExit(): void {
    this.close();
  }

  ngOnInit() {
    this.loading = true;
    this.callerIdService.getCallerIdCampaigns(this.data['caller_id']).subscribe(
      (r) => {
        this.camps = r;
        this.loading = false;
      }
    )
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/modals/caller-id-campaigns/caller-id-campaigns.component.ts